import { getAssetByTypeAndSource } from 'Pods/ThreeDStudio/Shared/Utils/getAssetByTypeAndSource'
import {
  ACTION,
  PROVIDER,
  VIEWER_SIDEBAR_TAB,
} from 'Pods/ThreeDStudio/Store/constants'

import { getModelFormatOutput } from './getModelFormatOutput'

/**
 * Builds the ThreeDStudio store patch for a Tripo3D mesh-segmentation-default
 * run. Segmentation has no user settings (input_3d only), so there is no
 * settings slice to restore - it just loads the output model and opens the
 * viewer sidebar on the SEGMENT tab.
 *
 * @param {Object} openedModel - Run object from the library
 * @returns {Object} parsedData - ThreeDStudio store patch
 */
export const parseTripo3dMeshSegmentationDefaultData = (openedModel) => {
  const {
    id: sessionId,
    modelFormatOutput: rawModelFormatOutput,
    generatorSessionId,
    outputAssets,
  } = openedModel
  const {
    assetId: inputThreeD,
    fileUrl: inputThreeDUrl,
  } = getAssetByTypeAndSource(outputAssets, '3d_model', 'ai_generated')
  const modelFormatOutput = getModelFormatOutput({
    modelFormatOutput: rawModelFormatOutput,
    modelUrl: inputThreeDUrl,
  })
  const enhancedProvider = PROVIDER.TRIPO3D
  const enhancedAction = ACTION.MESH_SEGMENTATION

  const schema = { enhancedAction, enhancedProvider }
  const generation = { sessionId, generatorSessionId }
  const viewer = { fileFormat: modelFormatOutput, inputThreeD }
  const ui = {
    isModelSettingsOpen: false,
    isViewerSidebarOpen: true,
    activeViewerSidebarTab: VIEWER_SIDEBAR_TAB.SEGMENT,
  }

  return {
    openedModel,
    schema,
    ui,
    generation,
    viewer,
  }
}
